module.exports = __webpack_public_path__ + "img/ring_g_l_null_1.d78c1139.png";